module.exports = __webpack_public_path__ + "assets/seller1w.986d4c85645ac20115ff8d4c5cd81217.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/seller1w.png
 ** module id = 185
 ** module chunks = 0
 **/